<template>
	<div class="page-login">
		<div class="container">
			<div class="login">

				<!-- Register Box -->
				<template v-if="!isShowRegisterInfo && !isVerification">
					<div class="login-box">
						<div class="login-wrapper p-5">
                            <div class="login-box-logo">
                                <img :src="appLogo" class="d-block m-auto" :alt="appName">
                            </div>

							<div class="h4 text-center font-weight-bold mb-4">
								Register Supplier
							</div>

							<div class="login-error callout callout--danger" v-if="registerError">
								<div class="callout__content">{{ registerError }}</div>
							</div>
							<form @submit.prevent="register()">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Name</label>
                                            <input type="text" name="name" class="form-control" :class="{ 'is-invalid': errorMessages.name }" placeholder="Full Name" v-model="name">
											<small v-if="errorMessages.name" class="text-danger">{{ errorMessages.name }}</small>
                                        </div>
                                        <div class="form-group">
                                            <label>Email</label>
                                            <input type="email" name="email" class="form-control" :class="{ 'is-invalid': (isHasErrorValidation('email') || errorMessages.email) }" placeholder="Email" v-model="email" @change="onEmailChange">
                                            <div v-if="isHasErrorValidation('email')" class="invalid-feedback">
                                                Email sudah terdaftar
                                            </div>
											<small v-if="errorMessages.email" class="text-danger">{{ errorMessages.email }}</small>
                                        </div>
                                        <div class="form-group">
                                            <label>Phone Number</label>
                                            <div class="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">+62</span>
                                                </div>
                                                <input type="text" name="phone" class="form-control" :class="{ 'is-invalid': errorMessages.phone }" placeholder="Phone / WA Number" v-model.trim="phone" @input="phoneValidation" minlength="9">
                                            </div>
											<small v-if="errorMessages.phone" class="text-danger">{{ errorMessages.phone }}</small>
                                        </div>
                                        <div class="form-group">
                                            <label>Password</label>
                                            <input type="password" name="password" class="form-control" :class="{ 'is-invalid': errorMessages.password }" placeholder="Password" v-model="password" minlength="6">
											<small v-if="errorMessages.password" class="text-danger">{{ errorMessages.password }}</small>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Business Name</label>
                                            <input type="text" name="businessName" class="form-control" :class="{ 'is-invalid': errorMessages.businessName }" placeholder="Business Name" v-model="businessName">
											<small v-if="errorMessages.businessName" class="text-danger">{{ errorMessages.businessName }}</small>
                                        </div>
										<div class="form-group">
											<label>Business City</label>
											<multiselect v-model="selectedSubdistrict" :custom-label="cityLabel"
												:show-labels="false" track-by="subdistrict_id"
												@close="subdistrictValidation"
												placeholder="Enter the City / District (minimum 3 letters)"
												:options="subdistricts"
												@search-change="fetchSubdistricts">
											</multiselect>
											<small v-if="errorMessages.subdistrict" class="text-danger">{{ errorMessages.subdistrict }}</small>
										</div>
                                        <div class="form-group">
                                            <label>Business Address</label>
                                            <textarea name="businessAddress" class="form-control" :class="{ 'is-invalid': errorMessages.address }" rows="3" placeholder="Business Address" v-model="businessAddress"></textarea>
											<small v-if="errorMessages.address" class="text-danger">{{ errorMessages.address }}</small>
                                        </div>
                                    </div>

									<div class="col-md-12">
										<div class="form-group text">
											<recaptcha v-if="isGoogleRecaptchaEnabled" ref="recaptcha"></recaptcha>
										</div>
									</div>

									<div class="col-md-6">
										<div class="form-group text">
											<button type="submit" class="btn btn-submit btn-primary w-100" :class="{ 'is-loading': isRegistering }">{{ $t('Register') }}</button>
										</div>
									</div>

                                </div>

							</form>
							<!-- <div class="text-right">
								<router-link
									class="login-action"
									to="/login"
								>
									{{ $t('Already have an account? Login here') }}
								</router-link>
							</div> -->
						</div>
					</div>
					<!-- <div class="auth-bottom-text hidden">
						<span>Doesn't have an account? </span>
						<a href="https://buy.ostock.id/free-account?utm_source=orderonline&utm_medium=login&utm_content=text" target="_blank">Create Free Account</a>
					</div> -->
				</template>

				<!-- Register Info -->
				<div class="login-box p-5" v-if="isShowRegisterInfo && !isVerification">
					<div class="thank-you-text">
						<div class="text-bold text-center text-dark">Thank you for registering at</div>
					</div>
					<div class="login-box-logo">
						<img :src="appLogo" class="d-block m-auto" :alt="appName">
					</div>
					<div class="login-error callout callout--danger" v-if="registerFailed">
						<div class="callout__content">{{ registerFailed }}</div>
					</div>
					<div class="login-error callout callout--info" v-if="registerSuccess">
						<div class="callout__title">{{ $t('Please Check Your Email') }}</div>
						<div class="callout__content">{{ `${$t("We've send an email verification to")} ${email}` }}</div>
					</div>
					<div class="text-right">
						<router-link
							class="login-action"
							to="/login"
						>
							{{ $t('Back to Login') }}
						</router-link>
					</div>
				</div>

				<!-- Verification Info -->
				<div class="login-box p-5" v-if="isVerification">
					<div class="login-box-logo">
						<img :src="appLogo" class="d-block m-auto" :alt="appName">
					</div>
					<div class="login-error callout callout--danger" v-if="verificationFailed">
						<div class="callout__title">{{ $t('Verification Failed') }}</div>
						<div class="callout__content">{{ $t('Verification code is no longer valid or has been used before.') }}</div>
					</div>
					<div class="login-error callout callout--info" v-if="verificationSuccess">
						<div class="callout__title">{{ $t('Verification Success') }}</div>
						<div class="callout__content">{{ $t("Congratulations now you can login to your account.") }}</div>
					</div>
					<div class="is-loading" v-if="isVerifying"></div>
					<div class="mt-5" v-if="isVerifying">
						<span class="text-muted">Verifying..</span>
					</div>
					<div class="text-right">
						<router-link
							class="login-action"
							to="/login"
						>
							{{ $t('Back to Login') }}
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import userApi from '@/api/user';
import {
	duplicateVar,
	getAxiosErrorMessage,
	getAxiosErrorValidation,
	getOS,
	getDeviceType,
	getBrowser,
} from '@/lib/helper';
import shipping from '@/api/shipping';
import Recaptcha from '@/components/Recaptcha.vue';

export default {
	name: 'login',
	components: {
		Recaptcha,
	},
	data() {
		return {
			title: 'Register',
			name: '',
			businessName: '',
			businessAddress: '',
			email: '',
			phone: '',
			password: '',
			registerError: null,
			isShowRegisterInfo: false,
			isVerification: false,
			registerSuccess: false,
			registerFailed: false,
			isRegistering: false,
			validations: [],
			verificationFailed: false,
			verificationSuccess: false,
			isVerifying: false,
			isLoadingSubdistrics: false,
			subdistrictKeyword: '',
			selectedSubdistrict: null,
			subdistricts: [],
			errorMessages: {
				name: '',
				email: '',
				phone: '',
				password: '',
				subdistrict: '',
				address: '',
				businessName: '',
			},
			ip: null,
			location: '',
			position: null,
			latitude: 0,
			longitude: 0,
			isLocating: false,
			locationData: null,
			isLocationFetched: true,
		};
	},
	methods: {
		...mapActions({
		}),
		register() {
			this.validateAllForm();
			const isErrorExist = Object.values(this.errorMessages).find(val => val !== '');
			if (isErrorExist) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Form harus diisi.',
				});
				return;
			}

			const gRecaptchaResponse = document.getElementsByName('g-recaptcha-response')[0]?.value ?? '';
			const ref = this.refQuery;

			if (this.isGoogleRecaptchaEnabled && gRecaptchaResponse === '') {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Recaptcha harus diisi.',
				});
			} else {
				this.isRegistering = true;
				const metaJson = JSON.stringify(this.meta);
				const params = {
					name: this.name,
					email: this.email,
					phone: this.phone,
					password: this.password,
					business_name: this.businessName,
					business_address: this.businessAddress,
					business_address_detail: this.addressDetail,
					is_supplier: true,
					meta: metaJson,
					g_recaptcha: gRecaptchaResponse,
				};

				if (ref !== null) {
					params.ref = ref;
				}

				const callback = (response) => {
					const message = response.message;
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Success',
						text: message,
					});
					this.isRegistering = false;
					this.isShowRegisterInfo = true;
					this.registerSuccess = true;

					this.triggerPixel();
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Failed',
						text: message,
					});
					this.validations = getAxiosErrorValidation(e);
					this.isRegistering = false;

					if (typeof window.grecaptcha !== 'undefined') {
						window.grecaptcha.reset();
					}
				};
				userApi.register(params, callback, errorCallback);
			}
		},
		triggerPixel() {
			if (!this.metaPixels || this.metaPixels.length === 0) return;

			const registerPixel = this.metaPixels.find(pixelItem => pixelItem.type === 'register');
			if (!registerPixel) return;

			const { ids: pixelIds = [], events: trackingEvents = [], enabled: isEnabled = false } = registerPixel;
			if (!isEnabled || pixelIds.length === 0 || trackingEvents.length === 0) return;

			try {
				pixelIds.forEach(pixelId => window.fbq('init', pixelId));
				trackingEvents.forEach(trackingEvent => window.fbq('track', trackingEvent));
			} catch (error) {
				const msg = getAxiosErrorMessage(error) || 'Error when triggering pixel';
				console.log(msg);
			}
		},
		isHasErrorValidation(name) {
			let hasError = false;
			if (this.validations[name] !== undefined) {
				hasError = true;
			}
			return hasError;
		},
		onEmailChange() {
			if (this.isHasErrorValidation('email')) {
				const validations = this.validations;
				delete validations.email;
				this.validations = validations;
			}
		},
		getIp() {
			const endpoint = 'https://public.orderonline.id/ip';
			Axios.get(endpoint)
				.then((response) => {
					const ip = response.data.ip;
					this.ip = ip;
				})
				.catch(() => {
					this.isLocationFetched = true;
				});
		},
		getLocation() {
			this.isLocating = true;
			if (navigator.geolocation) {
				const onSuccess = (pos) => {
					this.position = duplicateVar(pos);
					const lat = pos.coords.latitude;
					const long = pos.coords.longitude;
					this.latitude = lat;
					this.longitude = long;
					this.isLocating = false;
				};
				const onError = () => {
					this.isLocating = false;
				};
				navigator.geolocation.getCurrentPosition(onSuccess, onError);
			} else {
				this.isLocating = false;
			}
		},
		validateCode() {
			this.isVerifying = true;
			const params = {
				email: this.emailQuery,
				code: this.codeQuery,
			};
			const callback = () => {
				this.isVerifying = false;
				this.verificationSuccess = true;
				// this.$router.push(`/register-verification?verified=true`)
			};
			const errorCallback = ({ response: { data } }) => {
				const errorMessage = data.message;
				this.verificationFailed = true;
				this.isVerifying = false;
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: errorMessage,
				});
				// this.$router.push(`/register-verification?verified=false&message=${errorMessage}`);
			};
			if (this.emailQuery && this.codeQuery) {
				userApi.registerValidateCode(params, callback, errorCallback);
			}
		},
		// eslint-disable-next-line camelcase
		cityLabel({ province_name, city_name_with_type, subdistrict_name }) {
			// eslint-disable-next-line camelcase
			return `${province_name}, ${city_name_with_type}, ${subdistrict_name}`;
		},
		getSubdistricts() {
			this.isLoadingSubdistrics = true;
			const subdistrictIds = JSON.stringify(this.originIds);
			const params = {
				page: 1,
				subdistrict_ids: subdistrictIds,
				get_complete_data: true,
				keyword: this.subdistrictKeyword,
			};
			const callback = (response) => {
				const subdistricts = response.data;
				this.subdistricts = subdistricts;
				this.isLoadingSubdistrics = false;
			};
			const errorCallback = () => {
				// const message = getAxiosErrorMessage(e);
				const message = 'City / District not Found';
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Get Subdistricts',
					text: message,
				});
				this.isLoadingSubdistrics = false;
			};
			shipping.getCompleteSubdistricts(params, callback, errorCallback);
		},
		fetchSubdistricts(query) {
			if (query.length >= 3) {
				this.subdistrictKeyword = query;
				this.getSubdistricts();
			}
		},
		// Validation
		nameValidation() {
			if (this.name.length <= 0) {
				this.errorMessages.name = 'Nama Wajib Diisi';
			} else {
				this.errorMessages.name = '';
			}
		},
		businessNameValidation() {
			if (this.businessName.length <= 0) {
				this.errorMessages.businessName = 'Nama Perusahaan Wajib Diisi';
			} else {
				this.errorMessages.businessName = '';
			}
		},
		isEmailValid(email) {
			if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
				return true;
			}
			return false;
		},
		emailValidation() {
			if (this.email.length <= 0) {
				this.errorMessages.email = 'Email Wajib Diisi';
			} else if (!this.isEmailValid(this.email)) {
				this.errorMessages.email = 'Email Tidak Valid';
			} else {
				this.errorMessages.email = '';
			}
		},
		isPhoneError() {
			return (
				this.phone.trim() !== ''
				&& !new RegExp(/^\+\d+$/).test(this.phone.trim())
			);
		},
		phoneValidation() {
			const validPhone = this.isPhoneError();
			this.phone = this.phone.replace(/[^\d]/g, '');
			if (validPhone) {
				const firstSelection = this.phone.substring(0, 1);
				const secondSelection = this.phone.substring(0, 2);
				let phone = this.phone;
				if (secondSelection === '62') {
					phone = phone.replace('62', '');
				} else if (firstSelection === '0') {
					phone = phone.replace('0', '');
				}
				this.phone = phone;
				if (this.phone.length < 9) {
					this.errorMessages.phone = 'Nomor Telepon Minimal 9 Digit';
				} else {
					this.errorMessages.phone = '';
				}
			} else {
				this.errorMessages.phone = 'Nomor Telepon Tidak Valid';
			}
		},
		subdistrictValidation() {
			if (this.selectedSubdistrict) {
				this.errorMessages.subdistrict = '';
			} else {
				this.errorMessages.subdistrict = 'Kota / Kecamatan Harus Di Pilih';
			}
		},
		addressValidation() {
			if (this.businessAddress.length <= 0) {
				this.errorMessages.address = 'Alamat Lengkap Wajib Diisi';
			} else {
				this.errorMessages.address = '';
			}
		},
		passwordValidation() {
			if (this.password.length < 6) {
				this.errorMessages.password = 'Password Minimal Memiliki 6 Karakter';
			} else {
				this.errorMessages.password = '';
			}
		},
		validateAllForm() {
			this.nameValidation();
			this.emailValidation();
			this.phoneValidation();
			this.passwordValidation();
			this.businessNameValidation();
			this.subdistrictValidation();
			this.addressValidation();
			this.subdistrictValidation();
		},
	},
	computed: {
		...mapGetters({
			appName: 'appName',
			appLogo: 'appLogo',
			ooWeb: 'ooWeb',
			metaPixels: 'metaPixels',
			isGoogleRecaptchaEnabled: 'isGoogleRecaptchaEnabled',
		}),
		meta() {
			const os = getOS();
			const deviceType = getDeviceType();
			const browser = getBrowser();
			const location = this.location;
			const userAgent = window.navigator.userAgent;
			const meta = {
				ip: this.ip,
				os,
				device: deviceType,
				browser,
				location,
				lat: this.latitude,
				long: this.longitude,
				user_agent: userAgent,
			};
			return meta;
		},
		emailQuery() {
			return this.$route.query.email;
		},
		codeQuery() {
			return this.$route.query.code;
		},
		refQuery() {
			return this.$route?.query?.ref ?? null;
		},
		addressDetail() {
			let originAddress = {};

			if (this.selectedSubdistrict != null) {
				originAddress = {
					city: this.selectedSubdistrict.city,
					city_id: this.selectedSubdistrict.city_id,
					city_name: this.selectedSubdistrict.city_name,
					city_name_with_type: this.selectedSubdistrict.city_name_with_type,
					district_id: this.selectedSubdistrict.district_id,
					province_id: this.selectedSubdistrict.province_id,
					province_name: this.selectedSubdistrict.province_name,
					subdistrict_id: this.selectedSubdistrict.subdistrict_id,
					subdistrict_name: this.selectedSubdistrict.subdistrict_name,
					zip: this.selectedSubdistrict.zip,
				};
			}

			return originAddress;
		},
	},
	created() {
		document.body.classList.add('login');
		this.getIp();
		this.getLocation();
		if (this.emailQuery && this.codeQuery) {
			this.isVerification = true;
			this.validateCode();
		}
	},
	destroyed() {
		document.body.classList.remove('login');
		document.removeEventListener('click', this.onClick);
	},
	watch: {
		name() {
			this.nameValidation();
		},
		businessName() {
			this.businessNameValidation();
		},
		email() {
			this.emailValidation();
		},
		businessAddress() {
			this.addressValidation();
		},
		password() {
			this.passwordValidation();
		},
		referenceLink() {
			this.linkImageValidation();
		},
		submitError() {
			if (typeof window.grecaptcha !== 'undefined') {
				window.grecaptcha.reset();
			}
		},
		ip() {
			if (this.ip) {
				const geoApiKey = process.env.VUE_APP_GEODB_API_KEY;
				const endpoint = `https://geolocation-db.com/json/${geoApiKey}/${this.ip}`;
				Axios.get(endpoint)
					.then(({ data }) => {
						this.locationData = data;
						const city = data.city || 'Unknown city';
						const country = data.country_name || 'Unknown country';
						const location = `${city}, ${country}`;
						this.location = location;
						this.isLocationFetched = true;
					})
					.catch(() => {
						this.isLocationFetched = true;
					});
			}
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.navbar-brand {
	margin: 0 auto;
}

.login {
	padding-top: 4em;
	// text-align: center;
}

h3 {
	font-weight: 300;
}

.login-box {
	margin: 2em auto;
	// padding: 2.5em;
	max-width: 900px;
	background-color: #fff;
	border-radius: 16px;
	box-shadow: 0 1px 10px -4px #9c9c9c;

	@media (max-width: 575px) {
		margin-top: 0;
		padding: 1em;
		box-shadow: none;
	}
}

.login-box-logo {
	margin: 0 auto;
	margin-bottom: 2em;
	max-width: 210px;

	img {
		max-width: 100%;
		height: auto;
	}
}

.login-error {
	margin-bottom: 2em;
	font-size: .95em;
}

.login-action {
	display: inline-block;
	margin-top: 1em;
	// color: #75cfd8 !important;
	cursor: pointer;

	&:hover {
		text-decoration: underline !important;
	}
}

.btn-submit {
	padding-top: .5em;
	padding-bottom: .5em;
	font-weight: 600;
	text-transform: uppercase;
}

.nav-tabs {
	border-bottom: 0px solid transparent;

	.nav-link {
		border: 0px solid transparent;
		padding: 0.7rem 1rem;
	}

	:last-child{
		.nav-link {
			border-right: none;
			border-top-right-radius: 5px;
		}
	}
}

.thank-you-text {
	font-size: 2rem;
}
</style>
